import styled from "@emotion/styled";

type FormProps = {
  maxWidth?: string;
};

export const Form = styled.form<FormProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 0.75rem;
  width: 100%;
  max-width: ${(p) => p.maxWidth || "600px"};

  ${(p) => p.theme.media.mobileDown} {
    max-width: 100%;
  }

  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
    * {
      pointer-events: none;
    }
  }
`;
